import { Link } from "react-router-dom";
import blog1 from "../../../assets/images/all-img/blog2/dark/blog1.png";
import blog2 from "../../../assets/images/all-img/blog2/dark/blog2.png";
import blog3 from "../../../assets/images/all-img/blog2/dark/blog3.png";
import search from "../../../assets/images/svg2/search.svg";
 
export default function BlogSidebarSection() {
	return (
		<div className="fugu--blog-sidebar">
			<div className="fugu--blog-sidebar-item">
				<div className="fugu--newsletter fugu--search">
					<input type="email" placeholder="Search..." />
					<button type="submit" id="fugu--submit-btn">
						Search
					</button>
					<button id="fugu--search-btn">
						<img src={search} alt="" />
					</button>
				</div>
			</div>
			<div className="fugu--blog-sidebar-item">
				<h4>Categories:</h4>
				<div className="fugu--category">
					<ul>
						<li>
							<Link to={"#"}> Art & Analysis (04)</Link>
						</li>
						<li>
							<Link to={"#"}> Collectible (02)</Link>
						</li>
						<li>
							<Link to={"#"}> Metaverse (06)</Link>
						</li>
						<li>
							<Link to={"#"}> Utility (27)</Link>
						</li>
					</ul>
				</div>
			</div>
			<div className="fugu--blog-sidebar-item">
				<h4>Latest Posts:</h4>
				<div className="fugu--blog-post-wrap">
					<div className="fugu--blog-post-thumb">
						<Link to={"#"}>
							<img src={blog1} alt="" />
						</Link>
					</div>
					<div className="fugu--blog-post-data">
						<Link to={"#"}>
							<p>July 27, 2022</p>
						</Link>
						<Link to={"#"}>
							<h5>We’ve valued one of the biggest NFT portfolios in the world!</h5>
						</Link>
					</div>
				</div>
				<div className="fugu--blog-post-wrap">
					<div className="fugu--blog-post-thumb">
						<Link to={"#"}>
							<img src={blog2} alt="" />
						</Link>
					</div>
					<div className="fugu--blog-post-data">
						<Link to={"#"}>
							<p>July 27, 2022</p>
						</Link>
						<Link to={"#"}>
							<h5>One global or several tiny NFT communities? Traders version</h5>
						</Link>
					</div>
				</div>
				<div className="fugu--blog-post-wrap">
					<div className="fugu--blog-post-thumb">
						<Link to={"#"}>
							<img src={blog3} alt="" />
						</Link>
					</div>
					<div className="fugu--blog-post-data">
						<Link to={"#"}>
							<p>July 27, 2022</p>
						</Link>
						<Link to={"#"}>
							<h5>Always be on time on your metaverse event with Dwiss!</h5>
						</Link>
					</div>
				</div>
			</div>
			<div className="fugu--blog-sidebar-item">
				<h4>Tags:</h4>
				<div className="fugu--tags">
					<ul>
						<li>
							<Link to={"#"}> NFTs art</Link>
						</li>
						<li>
							<Link to={"#"}> Cryptocurrency</Link>
						</li>
						<li>
							<Link to={"#"}> Digital </Link>
						</li>
						<li>
							<Link to={"#"}> Analysis</Link>
						</li>
						<li>
							<Link to={"#"}> Earning</Link>
						</li>
						<li>
							<Link to={"#"}> Creative works</Link>
						</li>
					</ul>
				</div>
			</div>
		</div>
	);
}
